export default {
  navTab: ['今日日程', '我的日程', '已结束日程'],
  card: {
    group: '我的小组: ',
    location: '地点: ',
    viewCommitmentLetter: '查看承诺书',
    signCommitmentLetter: '已签承诺书',
    checkinPhoto: '拍照签到',
    interviewerCheckin: '已签到',
    viewArrangement: '查看安排',
  },
  noData: '暂无日程',
  signOut: {
    confirmMsg: '确定退出面试评分系统？',
    cancelMsg: '取消退出',
  },
  getSchedules401: '登录过期，请重新登录',
};
